var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5337 3.4281C32.5337 3.4281 33.1592 5.15969 32.5337 8.14215C35.5162 7.51671 37.2478 8.14215 37.2478 8.14215L30.1767 15.2132C30.1767 15.2132 28.2581 14.7748 26.6412 16.3917L22.7903 20.2426C23.0873 21.3547 22.7996 22.5904 21.9271 23.4628C20.6254 24.7646 18.5148 24.7646 17.2131 23.4628C15.9113 22.1611 15.9113 20.0505 17.2131 18.7488C18.0855 17.8764 19.3212 17.5886 20.4333 17.8856L24.2842 14.0347C25.9011 12.4178 25.4627 10.4992 25.4627 10.4992L32.5337 3.4281Z",
    fill: "#0092FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.785 9.32068C13.2764 3.8293 21.6464 2.97096 28.0376 6.74568L25.5824 9.20089C20.5812 6.67399 14.3201 7.49958 10.142 11.6777C4.93503 16.8847 4.93503 25.3269 10.142 30.5338C15.349 35.7408 23.7912 35.7408 28.9982 30.5338C33.1763 26.3558 34.0019 20.0947 31.475 15.0935L33.9302 12.6382C37.7049 19.0295 36.8466 27.3995 31.3552 32.8909C24.8465 39.3996 14.2937 39.3996 7.785 32.8909C1.27626 26.3822 1.27626 15.8294 7.785 9.32068Z",
    fill: "#0092FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.499 14.0347C15.7431 10.7907 20.6615 10.2414 24.4726 12.387C24.3026 12.7446 24.0447 13.0956 23.6949 13.4455L22.1737 14.9666C19.7468 13.9383 16.8344 14.4134 14.8561 16.3917C12.2526 18.9952 12.2526 23.2163 14.8561 25.8198C17.4596 28.4233 21.6807 28.4233 24.2842 25.8198C26.2625 23.8415 26.7375 20.9291 25.7093 18.5022L27.2304 16.981C27.5803 16.6311 27.9313 16.3732 28.2889 16.2033C30.4345 20.0143 29.8853 24.9328 26.6412 28.1769C22.7359 32.0821 16.4043 32.0821 12.499 28.1769C8.5938 24.2716 8.5938 17.94 12.499 14.0347Z",
    fill: "#0092FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.43bb672b466e3de216e3f8b6a476cbdd.svg";
export { ForwardRef as ReactComponent };